import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

export const setLastEnterCalendarTab = action('setLastEnterCalendarTab', (lastTime: OwaDate) => ({
    lastTime,
}));

export const resetCalendarTabDropViewState = action('resetCalendarDropViewState');

export const setShowDayDropHint = action('setShowDayDropHint', (shouldShow: boolean) => ({
    shouldShow,
}));

export const setDayViewDropTime = action('setDayViewDropTime', (dayViewDropTime: OwaDate) => ({
    dayViewDropTime,
}));
